import { render, staticRenderFns } from "./infoTracking.vue?vue&type=template&id=2040f896&"
import script from "./infoTracking.vue?vue&type=script&lang=js&"
export * from "./infoTracking.vue?vue&type=script&lang=js&"
import style0 from "./infoTracking.vue?vue&type=style&index=0&id=2040f896&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports